import React, { Component } from 'react'
import Axios from 'axios'
import { Link } from 'react-router-dom';

class Regulamento extends Component {
    constructor(props) {
        super(props)
        this.state = {
            regulamento: "",
            email: '',
            senha: '',
            auth: '',
            loggingIn: false,
            open: false,
            severity: 'danger',
            snackMessage: '',
            toggleExpand: false,
            sac: "99999999999",
            parametros: ''
        }
        this.getSAC();
        this.getRegulamento()
        this.expandir = this.expandir.bind(this)
    }

    async getParametros() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("parametros/");
            this.setState({ parametros: response.data })
        } catch (err) {
            console.log(err);
        }
    }


    async getSAC() {
        try {
            var axiosInstance = new Axios.create({baseURL: window.localStorage.getItem("apiUrl")});
            const response = await axiosInstance.get("parametros/get-sac");
            this.setState({sac: response.data.contatoSAC});
        } catch (err) {
            console.log(err);
        }
    }
    getRegulamento = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("parametros/regulamento");
            this.setState({ regulamento: response.data });
        } catch (err) {
            console.log(err);
            this.setState({ regulamento: JSON.stringify(err) });
        }
    };

    expandir() {
        this.setState({ toggleExpand: !this.state.toggleExpand })
    }

    render() {
        return (
            <div className="documentation">
                {/* Improved Modal */}
                <div className="modal fade" id="exampleModalCenter2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header border-0">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body p-0 ratio ratio-16x9">
                                <iframe 
                                    src="https://www.youtube.com/embed/QDL_77tUs3U" 
                                    title="Video explicativo do regulamento"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Enhanced Navigation */}
                <nav className={`navbar navbar-expand-lg navbar-dark ${this.state.toggleExpand ? 'navbg-1' : 'navbg-1'}`}>
                    <div className="container-fluid">
                        <button
                            className="navbar-toggler p-1"
                            type="button"
                            onClick={this.expandir}
                            aria-label="Toggle navigation"
                        >
                            <span className="text-light"><i class="fas fa-bars"></i></span>
                        </button>
                        
                        <div className={`collapse navbar-collapse ${this.state.toggleExpand ? 'show panel-show' : ''}`}>
                            <ul className="navbar-nav ml-auto align-items-center">
                                <li className={`nav-item mx-2 ${this.state.toggleExpand ? 'w-100 pl-3 pr-3' : ''}`}>
                                    <button 
                                        className={`btn text-white border-white ${this.state.toggleExpand ? 'w-100' : ''}`}
                                        data-toggle="modal" 
                                        data-target="#exampleModalCenter2"
                                    >
                                        <i className="fas fa-play mr-2"></i>Como funciona
                                    </button>
                                </li>
                                <li className={`nav-item mx-2 ${this.state.toggleExpand ? 'w-100 pl-3 pr-3' : ''}`}>
                                    <a 
                                        className={`btn text-white border-white ${this.state.toggleExpand ? 'w-100' : ''}`}
                                        href="https://www.youtube.com/c/SORTEFLASH"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fab fa-youtube mr-2"></i>Acompanhe
                                    </a>
                                </li>
                                <li className={`nav-item mx-2 ${this.state.toggleExpand ? 'w-100 pl-3 pr-3' : ''}`}>
                                    <a 
                                        className={`btn text-white border-white ${this.state.toggleExpand ? 'w-100' : ''}`}
                                        href="/geral-ganhadores"
                                    >
                                        <i className="fas fa-trophy mr-2"></i>Ganhadores
                                    </a>
                                </li>
                                <li className="nav-item mx-2">
                                    <a 
                                        className="nav-link text-white"
                                        href={`https://api.whatsapp.com/send?phone=55${this.state.sac}&text=Preciso de ajuda`}
                                    >
                                        <i className="fas fa-comments mr-1"></i>Suporte
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>

                {/* Main Content Section */}
                <div className="wrapper mt-5">
                    <div className="page-header section-dark" style={{ backgroundImage: "url('./assets/img/regulamento-bg.jpg')" }}>
                        <div className="content-center">
                            <div className="container panel-reg">
                                <div className="card shadow-lg">
                                    <div className="card-header bg-primary text-white">
                                        <h2 className="title text-center mb-0">REGULAMENTO</h2>
                                    </div>
                                    <div className="card-body regulamento-content">
                                        <pre className="text-dark mb-0">
                                            {this.state.regulamento}
                                        </pre>
                                    </div>
                                    <div className="card-footer bg-light text-right">
                                        <small className="text-muted">
                                            Última atualização: {new Date().toLocaleDateString()}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Footer */}
                    <footer className="footer bg-dark text-white">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6 text-center text-md-left">
                                    <ul className="nav">
                                        <li className="nav-item">
                                            <Link className="nav-link" to="/sobre">
                                                Sobre nós
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link" to="/regulamento">
                                                Regulamento
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link" to="/projetos">
                                                Projetos
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-6 text-center text-md-right mt-3 mt-md-0">
                                    <p className="mb-0">
                                        © {new Date().getFullYear()} SorteFlash
                                        <br />
                                        <a 
                                            href="https://www.instagram.com/sorteflash/" 
                                            className="text-white"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <i className="fab fa-instagram mr-2"></i>
                                            @sorteflash
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </footer>
                </div>

                <style jsx>{`
                    .regulamento-content {
                        max-height: 70vh;
                        overflow-y: auto;
                        font-size: 1rem;
                        line-height: 1.6;
                    }
                    
                    pre {
                        white-space: pre-wrap;
                        word-wrap: break-word;
                        font-family: inherit;
                        background: transparent;
                        border: none;
                        padding: 1rem;
                    }
                    
                    .page-header.section-dark {
                        min-height: 100vh;
                    }
                    
                    .card {
                        border-radius: 15px;
                        margin-top: 2rem;
                    }
                    
                    .btn-round {
                        border-radius: 30px;
                        padding: 0.75rem 2rem;
                    }
                    .navbg-1{
                        background-color: #007bff !important;
                    }
                    .panel-reg{
                        max-width: 800px
                    }
                    .panel-show {
                        background-color: #007bff !important;
                        height: 300px
                    }
                `}</style>
            </div>
        )
    }
}

export default Regulamento
